"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChatDeletedError = isChatDeletedError;
exports.getChatDeletedMessage = getChatDeletedMessage;
exports.ApiErrorHandler = ApiErrorHandler;
const domain_1 = require("@home-health-notify/domain");
const Sentry = __importStar(require("@sentry/react"));
const i18next_1 = __importDefault(require("i18next"));
// Values are i18n keys under the `common` namespace.
const API_ERROR_MESSAGE_KEYS = {
    CONFLICT: "errors.patientDuplicate",
    RESOURCE_NOT_FOUND: "errors.groupNotAvailable",
    GONE: "errors.chatDeleted",
};
const GONE_STATUS = 410;
/**
 * A chat the backend has deleted. Callers handle it themselves rather than pass
 * it to ApiErrorHandler, because the copy names the chat and the surrounding UI
 * has to lock rather than just report.
 */
function isChatDeletedError(e) {
    if ((0, domain_1.isApiError)(e))
        return e.statusCode === GONE_STATUS;
    const response = e === null || e === void 0 ? void 0 : e.response;
    return (response === null || response === void 0 ? void 0 : response.status) === GONE_STATUS;
}
/**
 * The backend's own 410 copy carries a raw chat id ("Chat 6a15... is deleted"),
 * so the name comes from the client instead, when it has one.
 */
function getChatDeletedMessage(chatName) {
    return chatName
        ? i18next_1.default.t("errors.chatDeletedNamed", { ns: "common", name: chatName })
        : i18next_1.default.t("errors.chatDeleted", { ns: "common" });
}
function resolveErrorMessageByType(errorType) {
    if (!errorType)
        return undefined;
    const key = API_ERROR_MESSAGE_KEYS[errorType];
    return key ? i18next_1.default.t(key, { ns: "common" }) : undefined;
}
function getApiErrorMessage(error) {
    var _a;
    return (_a = resolveErrorMessageByType(error.errorType)) !== null && _a !== void 0 ? _a : error.displayMessage;
}
function ApiErrorHandler(e, enqueueSnackbar, customMessage = domain_1.ErrorMessages.genericError, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { form, onApiError } = options !== null && options !== void 0 ? options : {};
    // 1. Let caller handle specific ApiError cases first
    if ((0, domain_1.isApiError)(e) && (onApiError === null || onApiError === void 0 ? void 0 : onApiError(e))) {
        return;
    }
    // 2. ApiError with field-level errors + form → push to form
    if ((0, domain_1.isApiError)(e) && e.fieldErrors.length > 0 && form) {
        for (const { field, message } of e.fieldErrors) {
            form.setError(field, { message });
        }
        enqueueSnackbar &&
            enqueueSnackbar(getApiErrorMessage(e), {
                variant: "error",
                autoHideDuration: 3000,
            });
        return;
    }
    // 3. ApiError → snackbar with frontend message (or fallback to displayMessage)
    if ((0, domain_1.isApiError)(e)) {
        console.error(e);
        enqueueSnackbar &&
            enqueueSnackbar(getApiErrorMessage(e), {
                variant: "error",
                autoHideDuration: 3000,
            });
        return;
    }
    // 4. Existing logic — unchanged for non-ApiError cases
    const responseType = (_c = (_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : (_e = (_d = e === null || e === void 0 ? void 0 : e.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.responseType;
    const mappedMessage = resolveErrorMessageByType(responseType);
    const message = mappedMessage ||
        (((_g = (_f = e === null || e === void 0 ? void 0 : e.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.responseType) && ((_j = (_h = e === null || e === void 0 ? void 0 : e.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.message)
            ? (_l = (_k = e === null || e === void 0 ? void 0 : e.response) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.message
            : customMessage);
    if (process.env.NODE_ENV === "production") {
        const isNoInternetError = e.code === "NO_INTERNET";
        const isInvalidAuthTokenError = e.code === "FORCE_LOGOUT";
        const isKnownBusinessError = !!(responseType && API_ERROR_MESSAGE_KEYS[responseType]);
        if (!isNoInternetError &&
            !isInvalidAuthTokenError &&
            !isKnownBusinessError) {
            const eventId = Sentry.captureException(e);
            Sentry.showReportDialog({
                eventId,
                title: "Something went wrong",
                subtitle: "Please help us fix it by sharing what happened.",
            });
        }
    }
    console.error(e);
    enqueueSnackbar &&
        enqueueSnackbar(message, { variant: "error", autoHideDuration: 3000 });
}
